<template>
  <div id="alerts">
    <vue-loading :active.sync="loading" :is-full-page="true" loader="dots" color="#70A1F0"></vue-loading>
    <nav class="navbar fixted-top navbar-light bg-light">
      <div class="navbar-brand">Alerts</div>
      <ul class="nav nav-pages mr-auto">

        <li class="nav-item">
          <a class="nav-link" :class="{'active': view === 'summary'}" type="button" @click="view='summary'">summary</a>
        </li>

        <li class="nav-item">
          <a class="nav-link" :class="{'active': view === 'all'}" type="button" @click="view='all'">all alerts</a>
        </li>
      </ul>

      <button type="button" class="btn btn-sm btn-primary" style="float: right; cursor: pointer;" v-on:click="downloadCSV">Download Report</button>
    </nav>

    <div class="row">
      <div class="column">
        <MetricGraph :metrics='metrics'
          :name='"Total Alerts"'
          :date='date'
          :period='period'
          :lastUpdate='lastUpdate'
          :metricProperties=metricProperties
          :metricProperty=metricProperty
          v-on:updateMetric='updateMetric' />
      </div>

      <div class="column">
        <div id="timeline" v-if="loaded">
          <transition name="fade" appear>
            <div class="card">
              <div class="card-body" style="padding: 0;">
                <AlertPriorityCount
                  :labels="labels"
                  :critical="timeline.P1"
                  :downgraded="timeline.P2"
                  :warning="timeline.P4"
                  :task="timeline.P3"
                  :informational="timeline.P5"/>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>

    <div v-if="view === 'all'">
      <div class="row">
        <div class="column">
          <transition name="fade" appear>
            <div class="table-margin">
              <vue-good-table
                :columns="alertColumns"
                :rows="alertRows()"
                :search-options="{
                  enabled: true,
                  skipDiacritics: true,
                  placeholder: 'filter alerts',
                }"
                :pagination-options="{
                  enabled: true,
                  perPage: 50,
                  position: 'top',
                }"
                styleClass="vgt-table condensed">
                <div slot="emptystate">
                  No alerts
                </div>
              </vue-good-table>
            </div>
          </transition>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row">
        <div class="column">
          <div id="uptime" class="uptime" v-if="loaded">
            <transition name="fade" appear>
              <Uptime :alerts='allAlerts' :downtime='downtime'/>
            </transition>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="column">

          <div id="timeline" v-if="alertsLoaded">
            <transition name="fade" appear>
              <div class="card">
                <div class="card-heading" style="padding-left: 15px;">
                  <h5 class="card-title">Timeline (UTC)</h5>
                </div>
                <div class="card-body" style="padding: 0;">
                  <AlertTimeline
                    :period="period"
                    :date='date'
                    :alerts="allAlerts"/>
                </div>
              </div>
            </transition>
          </div>

        </div>
      </div>

      <div class="row">
        <div class="column">
          <div id="incidents" class="incidents" v-if="loaded && incidents.length > 0">
            <Incidents :incidents='incidents' />
          </div>
        </div>

        <div class="column">

          <div id="alerts" class="alerts" v-if="loaded && Object.keys(alerts).length > 0">
            <AlertsPriorityList :alerts='alerts' />
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HTTP from '@/common/http'
import AlertPriorityCount from '@/components/charts/AlertPriorityCount'
import AlertTimeline from '@/components/charts/AlertTimeline'
import Uptime from '@/components/Alerts/Uptime'
import MetricGraph from '@/components/MetricGraph'
import Incidents from '@/components/Alerts/Incidents'
import AlertsPriorityList from '@/components/Alerts/AlertsPriorityList'
import VueLoading from 'vue-loading-overlay'
import { mapGetters } from 'vuex'

export default {
  name: 'Alerts',
  components: {
    VueLoading,
    AlertPriorityCount,
    AlertTimeline,
    Uptime,
    MetricGraph,
    Incidents,
    AlertsPriorityList
  },
  props: [
    'id'
  ],
  computed: {
    ...mapGetters([
      'activeType'
    ])
  },
  data () {
    return {
      labels: [],
      alerts: {},
      allAlerts: {},
      downtime: {},
      timeline: {},
      metrics: [],
      incidents: [],
      loading: false,
      loaded: false,
      alertsLoaded: false,
      ReportLoaded: false,
      period: 'week',
      date: null,
      lastUpdate: 'unknown',
      metricProperties: [
        'total',
        'critical',
        'downgraded',
        'warning',
        'task',
        'info'
      ],
      metricProperty: 'total',
      view: 'summary',
      alertColumns: [
        {
          label: 'Alert',
          field: 'name'
        },
        {
          label: 'Priority',
          field: 'priority'
        },
        {
          label: 'Opened',
          field: 'timestamp',
          type: 'date',
          dateInputFormat: 't',
          dateOutputFormat: 'MMM do KK:mm a'
        },
        {
          label: 'Acknowledged',
          field: 'ackTime',
          type: 'date',
          dateInputFormat: 't',
          dateOutputFormat: 'MMM do KK:mm a'
        },
        {
          label: 'Closed',
          field: 'closeTime',
          type: 'date',
          dateInputFormat: 't',
          dateOutputFormat: 'MMM do KK:mm a'
        }
      ]
    }
  },

  methods: {
    downloadCSV: function () {
      this.flashMessage.info({
        message: 'Genrating alerts CSV report',
        time: 3000
      })
      HTTP.get(`/alerts/csv/${this.activeType}/${this.id}/${this.period}/${this.date}`)
        .then((response) => {
          window.location = response.data.signedUrl
          this.flashMessage.success({
            message: 'Alerts CSV report generation complete'
          })
        })
        .catch((error) => {
          var msg = (error.response) ? error.response.data.error : error.message
          this.flashMessage.error({
            message: `Failed to generate alerts CSV report : ${msg}`
          })
        })
    },
    getReport: function () {
      this.loading = true
      this.loaded = false
      this.ReportLoaded = false
      HTTP.get(`/alerts/summary/${this.activeType}/${this.id}/${this.period}/${this.date}`)
        .then((response) => {
          this.alerts = response.data.alerts
          this.downtime = response.data.downtime
          this.timeline = response.data.timeline.days
          if (response.data.incidents) {
            this.incidents = response.data.incidents
          }
          this.setLabels()
        })
        .catch((error) => {
          var msg = (error.response) ? error.response.data.error : error.message
          this.flashMessage.error({
            message: `Failed to get alert summary : ${msg}`
          })
        })
        .finally(() => {
          this.loaded = true
          this.loading = false
          this.ReportLoaded = true
        })
    },
    getAllAlerts: function () {
      this.alertsLoaded = false
      HTTP.get(`/alerts/${this.activeType}/${this.id}/${this.period}/${this.date}`)
        .then((response) => {
          this.allAlerts = response.data.alerts
        })
        .catch((error) => {
          var msg = (error.response) ? error.response.data.error : error.message
          this.flashMessage.error({
            message: `Failed to get alerts : ${msg}`
          })
        })
        .finally(() => {
          this.alertsLoaded = true
        })
    },
    getMetrics: function () {
      this.loading = true
      HTTP.get(`/alerts/metrics/${this.activeType}/${this.id}/${this.period}`)
        .then((response) => {
          this.metrics = response.data['metrics']
          this.date = response.data['metrics'][11]['date']
          this.lastUpdate = response.data.metrics[11]['last_update'].toString()
        })
        .catch((error) => {
          var msg = (error.response) ? error.response.data.error : error.message
          this.flashMessage.error({
            message: `Failed to get alert metrics : ${msg}`
          })
        })
        .finally(() => {
          if (this.ReportLoaded) {
            this.loading = false
          }
        })
    },
    getPriorityClass: function (priority) {
      return {
        critical: (priority === 'P1'),
        downgraded: (priority === 'P2'),
        task: (priority === 'P3'),
        warning: (priority === 'P4'),
        informational: (priority === 'P5')
      }
    },
    getPriorityName: function (priority) {
      switch (priority) {
        case 'P1':
          return 'critical'
        case 'P2':
          return 'downgraded'
        case 'P3':
          return 'task'
        case 'P4':
          return 'warning'
        case 'P5':
          return 'info'
        default:
          return 'unknown'
      }
    },
    setLabels: function () {
      if (this.period === 'week') {
        var startOfWeek = this.$moment(this.date, 'YYYY-WW').startOf('week')
        this.labels = Array.from({length: 7}, (v, k) => startOfWeek.day(k + 1).format('dd (DD/MM)'))
      } else if (this.period === 'month') {
        var count = this.$moment(this.date, 'YYYY-MM').daysInMonth()
        this.labels = Array.from({length: count}, (v, k) => k + 1)
      }
    },
    friendlyDuration: function (seconds) {
      // use dummy date to calulate the amount of hours, minutes and seconds from seconds
      // dosn't matter what 2015-01-01 is
      var format = 's [seconds]'
      if (seconds > 59) {
        format = 'm [minutes] ' + format
      }
      if (seconds > 3599) {
        format = 'H [hours] ' + format
      }
      return this.$moment('2015-01-01').startOf('day').seconds(seconds).format(format)
    },
    updateMetric: function (event) {
      switch (event.eventType) {
        case 'date':
          this.date = event.data.date
          this.lastUpdate = event.data.lastUpdate.toString()
          break

        case 'period':
          this.period = event.data.period
          break

        case 'metricProperty':
          this.metricProperty = event.data.metricProperty
          break

        default:
          console.log(event)
          break
      }
    },
    alertRows: function () {
      var rows = []
      for (var priority in this.allAlerts) {
        rows.push(...this.allAlerts[priority]
          .map(alert => ({...alert, priority: this.getPriorityName(priority)})))
      }
      return rows
    }
  },
  created: function () {
    this.getMetrics()
  },
  watch: {
    id: function () {
      this.date = null
      this.getMetrics()
    },
    period: function () {
      this.getMetrics()
    },
    date: function () {
      if (this.date != null) {
        this.getReport()
        this.getAllAlerts()
      }
    }
  }
}
</script>

<style scoped src='../assets/stylesheet/alerts.css'></style>



// WEBPACK FOOTER //
// src/views/Alerts.vue